<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div style="float: right">
        <md-button class="md-success" @click="$router.push({ path: 'admin-email-configuration-create'})">Create Email Config</md-button>
      </div>
      <md-card>
        <md-card-content>
          <md-table v-model="tableData" table-header-color="green" md-fixed-header>
            <md-table-row slot="md-table-row" slot-scope="{ item }">            
              <md-table-cell md-label="Domain">{{ item.domain }}</md-table-cell>
              <md-table-cell md-label="Credentials">
                <a :href="GetServerBaseUrl() + 'config/custom/' + item.credentials" target="_blank">Download</a>
              </md-table-cell>
              <md-table-cell md-label="Auth Url" v-if="item.auth_url">Copy &nbsp;<md-button class="md-just-icon md-success" @click="CopyContent(item.auth_url)"><md-icon>content_copy</md-icon></md-button></md-table-cell>
              <md-table-cell md-label="Auth Url" v-else>-</md-table-cell>
              <md-table-cell md-label="Created On">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button class="md-just-icon md-danger m-0" @click="DeleteEmailConfig(item._id)"><md-icon>close</md-icon></md-button>
                &nbsp;<md-button class="md-just-icon md-primary m-0" @click="SendTestEmail()"><md-icon>email</md-icon></md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>  
      </md-card>
    </div>
  </div>
</template>
<script>
import DomainDataService from "../../../services/SuperAdmin/DomainDataService";
import Swal from "sweetalert2";

export default {
  components: {
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],
    };
  },
  methods: {
      EmailConfigList() {
        DomainDataService.EmailConfigList()
          .then((response) => {
            if (response.data.data) {
              this.tableData = response.data.data;
            }
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
      },
      
      DeleteEmailConfig(id) {
        Swal.fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            var data = { "id" : id };
            DomainDataService.DeleteEmailConfig(data)
              .then((response) => {
                this.$toast.success(response.data.respones_msg);
                this.EmailConfigList();
              })
              .catch((e) => {
                if (e.response) {
                  this.$toast.error(e.response.data.respones_msg);
                }
              });
          }
        });
      },

      SendTestEmail() {
        DomainDataService.SendTestEmail()
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
      },

      CopyContent(content) {
        navigator.clipboard.writeText(content);
        this.$toast.success("text copied");
      },
  },
  beforeMount() {
    this.EmailConfigList();
  },
};
</script>

<style>
</style>
